import apiClient from 'apiClient';

const fetchTags = (type = 'media') => (dispatch, getState) => {
  const state = getState();
  const companyId = state.user.company_id;
  return apiClient.get(`/companies/${companyId}/tags`, { type });
};

const createTag = (data) => (dispatch, getState) => {
  const state = getState();
  const companyId = state.user.company_id;
  return apiClient.post(`/companies/${companyId}/tags`, { tag: data });
};

const updateTag = (tagId, data) => () =>
  apiClient.put(`/tags/${tagId}`, { tag: data });

export { fetchTags, createTag, updateTag };
